// src/v3/account/documents.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var DocumentsIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "DocumentsIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M22.9688 10.3725C22.8295 10.1795 22.6464 10.0224 22.4345 9.91416C22.2226 9.80592 21.988 9.74965 21.75 9.75H20.25V8.25C20.25 7.85218 20.092 7.47064 19.8107 7.18934C19.5294 6.90804 19.1478 6.75 18.75 6.75H12.2503L9.65063 4.8C9.39054 4.60611 9.07503 4.50094 8.75062 4.5H3.75C3.35218 4.5 2.97064 4.65804 2.68934 4.93934C2.40804 5.22064 2.25 5.60218 2.25 6V19.5C2.25 19.6989 2.32902 19.8897 2.46967 20.0303C2.61032 20.171 2.80109 20.25 3 20.25H19.7906C19.948 20.25 20.1015 20.2005 20.2292 20.1085C20.3569 20.0164 20.4524 19.8865 20.5022 19.7372L23.1731 11.7244C23.2482 11.4989 23.2689 11.2589 23.2334 11.0239C23.1978 10.7889 23.1072 10.5657 22.9688 10.3725ZM8.75062 6L11.3503 7.95C11.6103 8.14401 11.9259 8.2492 12.2503 8.25H18.75V9.75H6.54094C6.2261 9.74998 5.91924 9.84902 5.66382 10.0331C5.4084 10.2172 5.21738 10.4769 5.11781 10.7756L3.75 14.8781V6H8.75062ZM19.2506 18.75H4.04062L6.54094 11.25H21.75L19.2506 18.75Z"
  }
) });

export {
  DocumentsIcon
};
